import { Component, OnInit } from '@angular/core';
import { Language } from '@core/utils';
import { FeatureFlagService, LanguageService, ProviderSettingsService } from '@core/services';
import { ProviderContactData } from '@shared/models';

@Component({
  selector: 'app-customer-service-info',
  templateUrl: './customer-service-info.component.html',
  styleUrl: './customer-service-info.component.scss',
})
export class CustomerServiceInfoComponent implements OnInit {
  contactData!: ProviderContactData;
  publicProductsPageEnabled = false;

  constructor(
    private languageService: LanguageService,
    private providerSettingsService: ProviderSettingsService,
    private featureFlagService: FeatureFlagService,
  ) {}

  ngOnInit() {
    this.contactData = this.providerSettingsService.getContactData();
    this.publicProductsPageEnabled = this.featureFlagService.getFeatureFlag('enable_public_products');
  }

  getCurrentLanguage(): string {
    return this.languageService.getCurrentLanguage();
  }

  changeLanguage(language: Language): void {
    this.languageService.setLanguage(language);
  }
}
